import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import identity from "xojs/lib/callbacks/identity";
import request from "superagent";
import configure from "./configure/index.js";
var FavoritesClient = /*#__PURE__*/function () {
  function FavoritesClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, FavoritesClient);
    var _configure = configure(config),
      host = _configure.host,
      apiKey = _configure.apiKey;
    this.host = host;
    this.apiKey = apiKey;
  }
  _createClass(FavoritesClient, [{
    key: "create",
    value: function create(_ref) {
      var sessionToken = _ref.sessionToken,
        data = _ref.data;
      return request.post("".concat(this.host, "/favorites")).query({
        apikey: this.apiKey
      }).set('MEMBERSHIP-SESSION-TOKEN', sessionToken).send({
        favorites: data
      }).then(identity);
    }
  }, {
    key: "get",
    value: function get(_ref2) {
      var sessionToken = _ref2.sessionToken,
        query = _ref2.query;
      return request.get("".concat(this.host, "/favorites")).query({
        apikey: this.apiKey
      }).query(query).set('MEMBERSHIP-SESSION-TOKEN', sessionToken).then(identity);
    }
  }, {
    key: "destroyByObjectId",
    value: function destroyByObjectId(_ref3) {
      var sessionToken = _ref3.sessionToken,
        query = _ref3.query;
      return request.del("".concat(this.host, "/favorites")).query({
        apikey: this.apiKey
      }).query(query).set('MEMBERSHIP-SESSION-TOKEN', sessionToken).then(identity);
    }
  }, {
    key: "destroy",
    value: function destroy(_ref4) {
      var _context;
      var sessionToken = _ref4.sessionToken,
        favoriteUUID = _ref4.favoriteUUID,
        query = _ref4.query;
      return request.del(_concatInstanceProperty(_context = "".concat(this.host, "/favorites/")).call(_context, favoriteUUID)).query({
        apikey: this.apiKey
      }).query(query).set('MEMBERSHIP-SESSION-TOKEN', sessionToken).then(identity);
    }
  }]);
  return FavoritesClient;
}();
export { FavoritesClient as default };